module.exports = __webpack_public_path__ + "img/lantern.ee5edc36.svg";